import React, { useEffect } from 'react';
import { clearSavedInviteParams } from '../../utils/urlParams';

type Props = {
  reason: 'invalid' | 'expired' | 'join_failed' | 'already_accepted' | 'not_found' | 'invalid_or_expired';
  closeModal?: () => void;
};

const InviteErrorModal: React.FC<Props> = ({ reason, closeModal }) => {
  useEffect(() => {
    return () => {
      try { clearSavedInviteParams(); } catch (e) {}
    };
  }, []);
  const message = reason === 'invalid' ? 'This invitation link is invalid.'
    : reason === 'expired' ? 'This invitation link has expired.'
    : reason === 'already_accepted' ? 'Invitation already accepted.'
    : reason === 'not_found' ? 'Invitation not found.'
    : reason === 'invalid_or_expired' ? 'This invitation link is invalid or has expired.'
    : 'Failed to join the tenant. Please try again or contact your administrator.';

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Invitation Issue</h3>
      <div className="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-700 text-red-800 dark:text-red-200 p-3 rounded">
        {message}
      </div>
      <div className="flex justify-end pt-2">
        <button className="btn btn-primary" onClick={closeModal}>OK</button>
      </div>
    </div>
  );
};

export default InviteErrorModal;


